import styled from 'styled-components';

export const DatePresets = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 0.5rem;
`;
